import { commonErrors } from '@utils/error';
import { requiredString } from '@utils/validation';
import { z } from 'zod';

export const dataConstants = {
	MEMBERSHIP_DURATION: 'membershipDuration',
	ANNUAL_MEMBERSHIP: 'ANNUAL',
	MONTHLY_MEMBERSHIP: 'MONTHLY',
};

export const testContent = {
	pageHeader: 'Membership plans',
	insuranceHeader: 'Your FOLX membership is covered by your insurance provider.',
	insuranceInfo: `You’ll be asked for a payment method on the next screen, because we need a card on file to establish your FOLX membership.

	But don’t worry, we will not charge your card on file!`,
	companyHeader: 'Your FOLX membership is covered by your employer, {company}.',
	companyInfo: `We'll collect your payment method today, so you can use it to schedule appointments with a FOLX clinician and for any medications they may prescribe.

	We will not charge you any fees for your monthly FOLX membership.`,
	disclaimer: '',
	membershipHeader: '',
	membershipSteps: [
		{
			info: `Book and see an LGBTQIA+ expert clinician within a few days`,
		},
		{
			info: `Have your prescriptions sent to a pharmacy or delivered via the FOLX pharmacy`,
		},
		{ info: `Message our member navigators, who can help you with resources and referrals` },
		{ info: `Get letters for surgery or name and gender marker changes` },
		{ info: `Explore the FOLX Community Platform` },
	],
	folx4folxHeader: 'Your FOLX membership is covered.',
	folx4folxInfo: `You’ll be asked for a payment method on the next screen, because we need a card on file to establish your FOLX membership.

	But don’t worry, we will not charge your card on file!`,
	folxMembershipOptionMonthly: {
		title: 'Monthly membership',
		price: '/ month',
		priceSubtext: 'after 10-day free trial!',
		description: `After your free trial, you'll be charged the monthly fee on the same day each month.`,
		badge: '',
		disclaimer: '',
		cta: 'Start your free 10 day trial',
	},
	folxMembershipOptionYearly: {
		title: 'Yearly membership',
		price: '/ year',
		priceSubtext: '',
		description: `Get a 40% discount when you prepay for the year. You'll be charged $299 today.`,
		badge: 'Save 40%',
		disclaimer: 'FOLX membership fees are nonrefundable.',
		cta: 'Pay for a yearly membership',
	},
};

export const schema = z.object({
	[dataConstants.MEMBERSHIP_DURATION]: requiredString(commonErrors.selectionRequired),
});
